module.exports = __webpack_public_path__ + "static/media/logo_dmjob.def35714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_dmjob.png
// module id = 294
// module chunks = 0